.spinner {
  width: 1em;
  height: 1em;

  svg {
    g {
      animation: rotate 2s linear infinite;
      transform-origin: center;

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }
    }
    circle {
      animation: dash 1.5s ease-in-out infinite;

      stroke: var(--primary);
      stroke-linecap: round;

      @keyframes dash {
        0% {
          stroke-dasharray: 0.01em, 3em;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 1.8em, 3em;
          stroke-dashoffset: -0.7em;
        }
        100% {
          stroke-dasharray: 1.8em, 3em;
          stroke-dashoffset: -2.49em;
        }
      }
    }
  }

  &.center {
    // TODO: Figure out why we need this
    width: unset;
    min-height: 1em;
  }
}
